import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChildren";

addToChainAfter(chain,PopulateApiParameter,props => {
    props.apiParameter.expand?.push("properties")
})
